import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullhorn } from "@fortawesome/free-solid-svg-icons";
import Switch from "@mui/material/Switch";
import { authFetch } from "../utils/api";
import "./notificationCenter.css";

// The portal's switch: company purple when on (as in the widget design and product sync settings).
const SWITCH_SX = {
  "& .MuiSwitch-switchBase.Mui-checked": { color: "#5616ea" },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#5616ea" },
  "& .MuiSwitch-track": { backgroundColor: "#ccc" },
};

// Product updates by e-mail (backend mail_prefs, ai-docs features/38): one switch for the whole account, saved at
// once. The same choice the unsubscribe link in every update mail changes.
export default function ProductUpdatesSetting() {
  const { t } = useTranslation();
  const [on, setOn] = useState(null);
  const [error, setError] = useState(false);
  const url = `${process.env.REACT_APP_API_BASE_URL}email/preferences`;

  useEffect(() => {
    let alive = true;
    authFetch(url)
      .then((res) => (res && res.ok ? res.json() : null))
      .then((data) => alive && data && setOn(Boolean(data.updates)))
      .catch(() => {});
    return () => { alive = false; };
  }, [url]);

  const toggle = async () => {
    const next = !on;
    setOn(next);
    setError(false);
    try {
      const res = await authFetch(url, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: next }),
      });
      if (!res || !res.ok) throw new Error(String(res?.status));
    } catch (_e) {
      setOn(!next);
      setError(true);
    }
  };

  if (on === null) return null;
  return (
    <div className="notification-center-parent-container product-updates-setting">
      <div className="notification-center-container">
        <h4 className="widget-sub-header product-updates-head">{t("notify_updates_title")}</h4>
        <div className="product-updates-row">
          <div className="product-updates-text">
            <div className="live-notify-matrix-event-title">
              <FontAwesomeIcon icon={faBullhorn} className="live-notify-matrix-event-icon" />
              {t("notify_updates_label")}
            </div>
            <div className="live-notify-matrix-event-desc">
              {error ? <span className="product-updates-error">{t("notify_updates_error")}</span> : t("notify_updates_desc")}
            </div>
          </div>
          <Switch checked={on} onChange={toggle} sx={SWITCH_SX} inputProps={{ "aria-label": t("notify_updates_label") }} />
        </div>
      </div>
    </div>
  );
}
